// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_UploadMediaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/whatsapp_message_templates/upload_media
 *
 * Validates input for uploading a media file for a WhatsApp message template.
 * Multipart form: template_type (POST field) + media_file (file).
 */
import { registerContract } from './validate'

export interface WhatsappMessageTemplates_UploadMediaInput {
template_type: string
_files: unknown[]
}

registerContract('WhatsappMessageTemplates_UploadMediaInput', {
  template_type: { type: 'string',  required: true },
  _files:        { type: 'array',   required: true },
})
